import ChartThemeSelector from '@/components/ChartThemeSelector.vue';
import AppDropdown from '@/components/AppDropdown.vue';
export default {
  name: 'ChartThemeDropdown',
  components: {
    ChartThemeSelector,
    AppDropdown
  },
  props: {
    themes: {
      type: Array
    },
    modelValue: {
      type: Object
    }
  },
  computed: {
    currentTheme: {
      get() {
        console.log('this.modelValue', this.modelValue);
        this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      }
    }
  }
};